import { Auth } from "aws-amplify";

const isValidEmail = (email: any) => {
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailPattern.test(email);
};

export const obscureEmail = (email: any, setError: Function) => {
  if (!isValidEmail(email)) {
    setError(true);
    return;
  }

  const [name, domain] = email.split("@");
  return `${name[0]}${new Array(name.length - 1).join("*")}${
    name[name.length - 1]
  }@${domain}`;
};

const resendVerificationEmail = async (CognitoUser: any) => {
  const data = await Auth.verifyUserAttribute(CognitoUser, "email");
  console.log("Email verification code successfully retrieved", {
    CognitoUser,
    data,
  });
};

export const resendEmail = async (
  userType: string,
  cognitoUser: any,
  setCodeResent: Function,
  analyticsService: any,
  reportError: Function,
  setError: Function,
  setErrorMessage: Function
) => {
  try {
    if (userType === "selfService") {
      // Use Auth.resendSignUp() for selfService user type
      await Auth.resendSignUp(cognitoUser.username);
    } else {
      // Use resendVerificationEmail for other user types
      await resendVerificationEmail(cognitoUser);
    }

    setCodeResent(true);

    const eventLabel =
      userType === "candidate"
        ? "Signup - User requested new email verification code"
        : "SES - User requested new email verification code";
    analyticsService.track(eventLabel, {}, () => {});

    // Handle additional UI updates
  } catch (err) {
    console.error("Failed to resend email verification code", err);
    reportError("Failed to resend email verification code", err);
    setError(true);
    setErrorMessage("Failed to resend email verification code");
    setCodeResent(false);
  }
};
